import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from "recharts";
import { fmtMoney } from "@/lib/format";
import { useCompactMoney } from "@/lib/useCompactMoney";
import { ReportShell, PALETTE } from "./atoms";

export default function ExpenseView({ exp, onExport, onShare }) {
  const { money } = useCompactMoney();
  return (
    <ReportShell title="Expense Report" kind="expenses" onExport={onExport} onShare={onShare} testid="expense-view">
      <div className="grid lg:grid-cols-2 gap-6">
        <div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-[var(--ll-ink-muted)] mb-3">Breakdown</div>
          <div className="h-72" data-testid="expense-pie">
            <ResponsiveContainer>
              <PieChart>
                <Pie data={exp.by_category} dataKey="amount" nameKey="category" outerRadius={110} innerRadius={50}>
                  {exp.by_category.map((_, i) => <Cell key={i} fill={PALETTE[i % PALETTE.length]} />)}
                </Pie>
                <Tooltip
                  formatter={(v) => fmtMoney(v)}
                  contentStyle={{ background: "#fff", border: "1px solid #1B4332", borderRadius: 0, fontSize: 12, fontFamily: "IBM Plex Mono" }}
                />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div>
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[10px] uppercase tracking-widest text-[var(--ll-ink-muted)] border-b" style={{ borderColor: "var(--ll-border)" }}>
                <th className="px-3 py-2 font-medium">Category</th>
                <th className="px-3 py-2 font-medium text-right">Amount</th>
                <th className="px-3 py-2 font-medium text-right">% of Total</th>
              </tr>
            </thead>
            <tbody>
              {exp.by_category.map((r, i) => (
                <tr key={r.category} className="border-b" style={{ borderColor: "var(--ll-border)" }}>
                  <td className="px-3 py-2 flex items-center gap-2">
                    <span className="w-2.5 h-2.5 inline-block" style={{ background: PALETTE[i % PALETTE.length] }} />
                    {r.category}
                  </td>
                  <td className="px-3 py-2 text-right font-mono-fin">{fmtMoney(r.amount)}</td>
                  <td className="px-3 py-2 text-right font-mono-fin text-[var(--ll-ink-soft)]">{r.pct.toFixed(1)}%</td>
                </tr>
              ))}
              <tr className="border-t-2 border-[var(--ll-ink)]">
                <td className="px-3 py-2.5 font-medium">Total</td>
                <td className="px-3 py-2.5 text-right font-mono-fin font-medium" data-testid="expense-total">{money(exp.total)}</td>
                <td className="px-3 py-2.5 text-right font-mono-fin font-medium">100.0%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ReportShell>
  );
}
